// extracted by mini-css-extract-plugin
export default {"div":"ErrorP_div__0B6um","h1":"ErrorP_h1__z3HLg","p":"ErrorP_p__1R14l","i":"ErrorP_i__hTDVh"};